module.exports = __webpack_public_path__ + "static/media/400146_01.659298da.png";